module.exports = __webpack_public_path__ + "img/ic_16_arrow_left.6b03498c.svg";